import arrayValueFactoryFactory from './arrayValueFactoryFactory'
import integerValueFactory from './integerValueFactory'

const IntegerArrayValueFactory = arrayValueFactoryFactory.create(
  'Integer array',
  integerValueFactory
)

export default IntegerArrayValueFactory
